module.exports = __webpack_public_path__ + "media/fonts/SFProText-Regular-87d722f246f41640c8decc4a0179419d.woff";